import { isMobile } from 'react-device-detect'

import { ToastStyles, ToastType } from '../../types/ToastTypes'

export const containerClassName = `flex custom-lg items-start border border-solid p-16px rounded-12px ${
   isMobile ? 'w-[312px]' : 'max-w-[757px]'
}`

export const toastWithLinkContainerStyles = `
   flex custom-lg items-center border border-solid px-6 py-3 rounded-12px ${
      isMobile ? 'w-[312px]' : 'max-w-[757px]'
   }
`

export const toastTitleStyles = 'text-sm-semibold'

export const toastDescriptionStyles = 'text-sm-regular mt-4px'

export const leftIconContainerStyles = 'mr-12px'

export const contentContainerClassName =
   'flex flex-col justify-center pr-[24px] w-[max-content]'

export const closeContainerStyles = 'ml-[8px] cursor-pointer'

export const leftIconClassName = 'mr-12px'

export const buttonClassName = 'flex items-center mt-16px mr-8px'

export const actionsContainerClassName = 'flex flex-start'

export const getToastStyles = (
   theme: any,
   toastType: ToastType
): ToastStyles => {
   try {
      return {
         bgColor: theme[toastType].bgColor,
         borderColor: theme[toastType].borderColor,
         textColor: theme[toastType].textColor,
         closeIconColor: theme[toastType].closeIconColor,
         leftIconColor: theme[toastType].leftIconColor,
         buttonTextColor: theme[toastType].buttonTextColor
      }
   } catch {
      throw new Error(
         `The Toast Type Doesn't Exit. You can add this Toast Type in the theme config.`
      )
   }
}

export const inlineVariantContainerStyles = `
   flex justify-between items-start gap-[16px]
   w-[max-content] pr-[24px]
`

export const inlineVariantTitleWithAdditionalInfoStyles = `
   flex flex-col items-start gap-[4px]
   w-full
`
